import React, { Component, Fragment } from "react";
import { Form, Input, Grid, Button } from "semantic-ui-react";

class GetPackages extends Component {
  constructor() {
    super();
    this.state = {
      formData: {
        queryType: "Account ID",
        AccountId: "",
        PackageId: "",
      },
      accountIdErr: "",
    };
  }

  handleInputChange = (event) => {
    const { value, name } = event.target;
    const { formData } = this.state;
    formData[name] = value;
    this.setState({ formData, accountIdErr: "" });
    console.log(formData)
  };

  isValidated = () => {
    //console.log("hello hi");
    const { formData } = this.state;

    if (!formData.AccountId.trim()) {
      this.setState({ accountIdErr: "Account ID is required" });
      return false;
    }
    return true;
  };

  search = () => {
    const { formData } = this.state;
    const { getPackages, isFetching } = this.props;
    if (isFetching) return;

    if (this.isValidated()) {
      const params = {};

      params.accountId = formData.AccountId.trim();
      getPackages(params);
    }
  };

  render() {
    const { formData } = this.state;
    const { isFetching, back } = this.props;

    return (
      <Fragment>
        <Form loading={isFetching}>
          <Form.Field>
            <Grid>
              <Grid.Row>
                <Grid.Column computer={3} tablet={16} mobile={16} />
                <Grid.Column
                  computer={13}
                  tablet={16}
                  mobile={16}
                ></Grid.Column>
              </Grid.Row>
            </Grid>
          </Form.Field>

          <Form.Field>
            <Grid>
              <Grid.Row>
                <Grid.Column computer={3} tablet={16} mobile={16}>
                  <label className="label-bold">User ID:</label>
                </Grid.Column>
                <Grid.Column computer={13} tablet={16} mobile={16}>
                  <Input
                    name="AccountId"
                    value={formData.AccountId}
                    onChange={this.handleInputChange}
                    placeholder="User ID"
                    autoComplete="off"
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form.Field>
        </Form>

        <Grid>
          <Grid.Row></Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Button
                labelPosition="left"
                floated="right"
                color="blue"
                content="Search"
                icon="search"
                loading={isFetching}
                disabled={isFetching}
                onClick={this.search}
              />
              <Button
                basic
                labelPosition="left"
                floated="left"
                content="Back"
                icon="arrow left"
                onClick={back}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Fragment>
    );
  }
}

export default GetPackages;
